import _ from 'lodash';

import * as statuses from 'app/entity/utils/statuses';
import Errors from 'app/errors';

const createState = state => ({
  status: statuses.INITIAL,
  ...(state || {}),
});

export const generateEntityCid = () => _.uniqueId('entity-');

export const createEntity = (id, data, state) => {
  const { cid, ...cleanData } = data || {};
  return {
    cid: cid || generateEntityCid(),
    data: { ...cleanData, id },
    state: createState(state),
  };
};

export const createCollection = (entities, state, data) => ({
  entities: { ...(entities || {}) },
  state: createState(state),
  data: data || {},
});

export const formatSuccess = (messages, entity) => ({
  entity,
  status: statuses.SUCCESS,
  messages: _.get(messages, 'success'),
});

export const remove401StatusFromGetErrorResponse = (entityType, response) => {
  throw response.status === 401
    ? new Errors.DataGetError({
        resource: entityType,
        // Have to strip `status` from `response` to prevent
        // `autoPromiseMiddleware` from redirecting based on 401
        response: { ...response, status: null },
      })
    : response;
};
